import { FluxBani } from './cash-flow'

export function Payments() {
  return <FluxBani directie="expense" />
}
